import { create } from 'zustand';

interface TaskProgressData {
  taskId: string;
  status: string;
  progress: number;
  message: string;
  deviceSerial: string;
}

interface TaskStoreState {
  activeTasks: Record<string, TaskProgressData>;
  taskHistory: TaskProgressData[];
  setTaskProgress: (task: TaskProgressData) => void;
  removeTask: (taskId: string) => void;
  clearHistory: () => void;
}

export const useTaskStore = create<TaskStoreState>((set) => ({
  activeTasks: {},
  taskHistory: [],
  setTaskProgress: (task: TaskProgressData) =>
    set((state) => ({
      activeTasks: { ...state.activeTasks, [task.taskId]: task },
      taskHistory: [task, ...state.taskHistory].slice(0, 100),
    })),
  removeTask: (taskId: string) =>
    set((state) => {
      const remaining: Record<string, TaskProgressData> = {};
      for (const [key, value] of Object.entries(state.activeTasks)) {
        if (key !== taskId) {
          remaining[key] = value;
        }
      }
      return { activeTasks: remaining };
    }),
  clearHistory: () => set({ taskHistory: [] }),
}));
